module.exports = __webpack_public_path__ + "static/media/shareIconwhite.b86dbf10.svg";